import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const TRIGGER_PF_PROPOSAL_DETAILS_FETCH_REQUEST =
  "TRIGGER_PF_PROPOSAL_DETAILS_FETCH_REQUEST";

export interface InsuredDetail {
  id: string;
  contactId: string;
  email: string;
  insurerName: string;
  dob: string;
  height: string;
  weight: string;
  gender: string;
  medicalCondition: string;
  regularMedication: string;
  insuranceCompany: string;
  nicotine: string;
  loanAmount: number;
  loanFundingDuration: number;
  loanPerYear: Array<{
    year: number;
    loanAmount: number;
  }>;
}

export interface PfProposalDetailsResponse {
  data: {
    basicDetails: {
      proposalType: string;
      contactName: string;
      yearlyIncome: string;
      netWorth: string;
      isSamePerson: string;
      gender: string;
      streetAddress: string;
      city: string;
      state: string;
      country: string;
      zipCode: string;
      EIN: string;
      email: string;
    };
    insuredDetails: InsuredDetail[];
    planDetails: {
      planType: string;
      indexStrategy: string;
      annualPremium: number;
      paymentDuration: number;
      waiveSurrenderCharges: string;
      deathBenefit: number;
      whenDoesTheClientWantToReceiveIncome: string;
      collateralNeeded: string[];
      interestPayments: string;
      loanExit: string;
    };
    id: string;
    status: string;
    message: string;
    priorities: string;
  };
  state: boolean;
  status: string;
}

interface COMMON_TYPE {
  data: null | PfProposalDetailsResponse;
  error: null | any;
  loading: boolean;
}

interface INITIAL_STATE {
  proposalDetails: COMMON_TYPE;
}

const initialState: INITIAL_STATE = {
  proposalDetails: { data: null, error: null, loading: false },
};

export const pfProposalDetailsSlice = createSlice({
  name: "pfProposalDetails",
  initialState,
  reducers: {
    pfProposalDetailsLoading: (state) => {
      state.proposalDetails = {
        loading: true,
        data: null,
        error: null,
      };
    },
    pfProposalDetailsFetchSuccess: (state, action: PayloadAction<PfProposalDetailsResponse>) => {
      state.proposalDetails = {
        loading: false,
        data: action.payload,
        error: null,
      };
    },
    pfProposalDetailsFetchError: (state, action: PayloadAction<any>) => {
      state.proposalDetails = {
        loading: false,
        data: null,
        error: action.payload,
      };
    },
    resetPfProposalDetails: (state) => {
      state.proposalDetails = {
        loading: false,
        data: null,
        error: null,
      };
    },
  },
});

export const {
  pfProposalDetailsLoading,
  pfProposalDetailsFetchSuccess,
  pfProposalDetailsFetchError,
  resetPfProposalDetails,
} = pfProposalDetailsSlice.actions;

export const getPfProposalDetails = (state: RootState) => state.pfProposalDetailsReducer;

export default pfProposalDetailsSlice.reducer;
